import React, { useState, useEffect, useRef } from "react";
import "./cyfrowy_ai.css";

import { FaLinkedin, FaFacebook, FaMicrophone } from "react-icons/fa";
import { IoMdClose, IoMdSend } from "react-icons/io";
import { RiMessage2Line } from "react-icons/ri";
import {
  FiSettings,
  FiBarChart2,
  FiShield,
  FiGlobe,
  FiCpu,
  FiHeadphones,
} from "react-icons/fi";
import { BsTwitterX } from "react-icons/bs";
import { GiRobotHelmet } from "react-icons/gi";
import AIBotWidget from "./AIBotWidget";
import { GrRobot } from "react-icons/gr";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaSquareInstagram } from "react-icons/fa6";
import TalkingBot from './TalkingBot';

// --- Modal Component ---
const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          &times;
        </button>
        <h2>{title}</h2>
        {children}
      </div>
    </div>
  );
};

const CyfrowyAI = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [activeFilter, setActiveFilter] = useState("all");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const observerRef = useRef([]);

  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  const [isBotOpen, setIsBotOpen] = useState(false); 
  // State for active category
const [activeCategory, setActiveCategory] = useState("HR");

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 },
    );

    document.querySelectorAll(".fade-in-element").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  const products = [
    {
      id: 1,
      name: "Tele calling AI",
      category: "Customer Engagement",
      price: 299,
      description:
        "Automated customer engagement and lead generation for tele calling teams",
      features: [
        "Multi-language support",
        "Real-time collaboration",
        "CRM integration",
        "AI-driven tele calling",
      ],
      icon: "✍️",
      badge: "Popular",
    },
    {
      id: 2,
      name: "Chat Genie AI",
      category: "chat",
      price: 249,
      description: "Next-gen chatbot with natural language understanding",
      features: [
        "No coding required",
        "Context awareness",
        "Sentiment analysis",
      ],
      icon: "💬",
      badge: "Trending",
    },
    {
      id: 3,
      name: "VoiceAssist Plus",
      category: "voice",
      price: 199,
      description:
        "Intelligent voice recognition and automated customer support",
      features: ["24/7 availability", "95% accuracy", "Multi-language"],
      icon: "🎙️",
      badge: "Trending",
    },
    {
      id: 4,
      name: "AI Shoot room",
      category: "Vision",
      price: 399,
      description:
        "AI-powered dress room for virtual try-ons and fashion recommendations",
      features: [
        "Real-time detection",
        "Object recognition",
        "Custom training",
      ],
      icon: "👁️",
      badge: null,
    },
    {
      id: 5,
      name: "AI Document reader",
      category: "analytics",
      price: 249,
      description:
        " AI-powered document analysis and data extraction for business intelligence",
      features: [
        "Multi-format support",
        "Customizable extraction",
        "Integration ready",
      ],
      icon: "💬",
      badge: "Popular",
    },
    {
      id: 6,
      name: "E-sign AI",
      category: "content",
      price: 599,
      description:
        "AI-driven electronic signature solution for secure and efficient document signing",
      features: [
        "Bank-grade security",
        "Customizable templates",
        "Audit trails",
      ],
      icon: "🔐",
      badge: "Premium",
    },
  ];

  const featuresList = [
    {
      icon: <FiSettings />,
      title: "Easy Customization",
      desc: "Tailor AI tools to match your exact workflow",
    },
    {
      icon: <FiBarChart2 />,
      title: "Instant Analytics",
      desc: "Real-time insights and performance metrics",
    },
    {
      icon: <FiShield />,
      title: "Enterprise Security",
      desc: "Bank-grade encryption and compliance",
    },
    {
      icon: <FiGlobe />,
      title: "Global Scale",
      desc: "Deploy across regions seamlessly",
    },
    {
      icon: <FiCpu />,
      title: "Innovation Hub",
      desc: "Access cutting-edge AI technologies",
    },
    {
      icon: <FiHeadphones />,
      title: "24/7 Support",
      desc: "Expert support when you need it",
    },
  ];

  const testimonials = [
    {
      name: "Sarah Jenkins",
      role: "CEO, TechFlow",
      quote:
        "Cyfrowy.ai transformed our customer engagement metrics in just one month.",
    },
    {
      name: "Mark Wilson",
      role: "CTO, FinScale",
      quote: "The most seamless AI integration we've ever experienced.",
    },
  ];

  const filteredProducts =
    activeFilter === "all"
      ? products
      : products.filter((p) => p.category === activeFilter);

  const handleAddToCart = (product) => {
    setCartCount((prev) => prev + 1);
    setSelectedProduct(product);
    setTimeout(() => setSelectedProduct(null), 2000);
  };



const agentCategories = {
  HR: ["HR Helpdesk agent", "ESAT Survey Agent", "AI Hiring Assistant", "Exit Interview Agent", "AI Performance Review", "Leave & Attendance Query Agent", "AI L&D Agent", "Employee Onboarding Agent", "HR Policy Q&A Agent"],
  Marketing: ["AEO/GEO Optimizer Agent", "Competitor Marketing Tracker", "AI Internal Communication Agent", "ABM Agent", "Content Distribution Agent", "AI Webinar Agent", "AI Content Creation Agent", "Social Media Agent", "Ebook Generator Agent"],
  Sales: ["AI SDR Agent", "Prospect Research Agent", "Linkedin Outreach Agent", "Lead Enrichment Agent", "AI Phone Dialer", "AI Proposal Writer Agent", "AI Sales Coach", "AI Deal Nurturer", "Meeting prep Agent"],
  Support: ["AI Cross Channel Support", "CRM Case Generator", "Email Triage Agent", "Conversational Support Agent", "AI Phone Support Agent", "Support Interaction Agent"],
  Banking: ["KYC Compliance agent", "Fraud Detection Agent", "Customer Onboarding", "AI Loan Origination", "Invoice Payment Agent", "Real-Time Payment agent", "Regulatory Monitoring", "AML Agent", "AI Loan Servicing"],
  Insurance: ["Regulatory Compliance Audit", "Policy Underwriting Assistant", "Partner Quality Assurance Audit Agent", "Claims Processing Agent", "Document Extraction for Litigation Agent", "Policy Underwriting support Agent", "Partner QA Simulation Agent", "Claims Analysis Agent"],
  Others: ["RFP Creation Agent", "Investment Memo Generator Agent", "IT Helpdesk Agent", "Demand Forecasting Agent", "AI SRE Agent", "AI Cross Channel Support Agent", "Startup Evaluation Agent", "Cloud Cost Analyzer Agent"]
};




  return (
    <div className="cyfrowy-container">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-content">
          <div className="logo">
            {/* <span className="logo-icon">⚡</span> */}
            <span className="logo-text">Cyfrowy.ai</span>
          </div>

          <button
            className={`hamburger ${isNavOpen ? "active" : ""}`}
            onClick={() => setIsNavOpen(!isNavOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul className={`nav-links ${isNavOpen ? "active" : ""}`}>
            <li>
              <a href="#home" onClick={() => setIsNavOpen(false)}>
                Home
              </a>
            </li>
            <li>
              <a href="#products" onClick={() => setIsNavOpen(false)}>
                Products
              </a>
            </li>
            <li>
              <a href="#features" onClick={() => setIsNavOpen(false)}>
                Features
              </a>
            </li>
            <li>
              <a href="#pricing" onClick={() => setIsNavOpen(false)}>
                Pricing
              </a>
            </li>
            <li>
              <a
                href="#contact"
                onClick={() => {
                  setIsContactModalOpen(true);
                  setIsNavOpen(false);
                }}
              >
                Contact
              </a>
            </li>
          </ul>

          <div className="nav-actions">
            {/* <button className="cart-btn">
              <span className="cart-icon">🛒</span>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </button> */}
            <button
              className="cta-btn"
              onClick={() => setIsAuthModalOpen(true)}
            >
              Sign In
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-background">
          <div className="gradient-orb orb-1"></div>
          <div className="gradient-orb orb-2"></div>
          <div className="gradient-orb orb-3"></div>
          <div className="grid-pattern"></div>
        </div>

        <div className="hero-content">
          <h1 className="hero-title fade-in-element">
            <span className="title-word">Empower Your</span>
            <span className="title-word accent">Business with AI</span>
          </h1>

          <p className="hero-subtitle fade-in-element">
            Customize world-class AI tools tailored to your unique business
            needs. Deploy, scale, and dominate your industry.
          </p>

          <div className="hero-buttons fade-in-element">
            <button
              className="btn btn-primary"
              onClick={() => {
                setIsContactModalOpen(true);
                setIsNavOpen(false);
              }}
            >
              Contact Sales
            </button>
            <button className="btn btn-secondary">Get Price</button>
          </div>
        </div>

        {/* <div className="hero-visual fade-in-element">
          <div className="floating-card card-1">
            <div className="card-content">
              <span>✨</span>
              <p>AI-Powered</p>
            </div>
          </div>
          <div className="floating-card card-2">
            <div className="card-content">
              <span>🚀</span>
              <p>Lightning Fast</p>
            </div>
          </div>
          <div className="floating-card card-3">
            <div className="card-content">
              <span>🔧</span>
              <p>Customizable</p>
            </div>
          </div>
        </div> */}

        <div className="hero-visual fade-in-element">
          <div className="ai-core">
            <div className="core-pulse"></div>
            <div className="core-inner">
              <GrRobot size={60} color="#00d9ff" />
            </div>
          </div>

          <div className="floating-badge badge-1">
            <div className="badge-content">
              <span>⚡</span> Fast Solution
            </div>
          </div>
          <div className="floating-badge badge-2">
            <div className="badge-content">
              <span>🧠</span> Auto-Scale
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="about-section fade-in-element">
        <div className="container">
          <div className="about-grid">
            <div className="about-image fade-in-element">
              <img
                src="https://pumpmedya.com/wp-content/uploads/2024/08/Dijital-Pazarlamada-Yeni-Nesil-Stratejiler-Yapay-Zeka-Entegrasyonu.webp"
                alt="About Us"
              />
              {/* <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=800" alt="About Us" /> */}
            </div>
            <div className="about-content fade-in-element">
              <h2>Pioneering the Future of AI Integration</h2>
              <p>
                Cyfrowy.ai bridges the gap between complex AI research and
                practical business application. We empower teams to automate
                workflows, increase productivity, and stay ahead in a
                competitive landscape.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <h2 className="section-title fade-in-element">
            Why Choose Cyfrowy.ai?
          </h2>

          {/* <div className="features-grid">
            {[
              { icon: '⚙️', title: 'Easy Customization', desc: 'Tailor AI tools to match your exact workflow' },
              { icon: '📈', title: 'Instant Analytics', desc: 'Real-time insights and performance metrics' },
              { icon: '🔒', title: 'Enterprise Security', desc: 'Bank-grade encryption and compliance' },
              { icon: '🌍', title: 'Global Scale', desc: 'Deploy across regions seamlessly' },
              { icon: '💡', title: 'Innovation Hub', desc: 'Access cutting-edge AI technologies' },
              { icon: '👥', title: '24/7 Support', desc: 'Expert support when you need it' }
            ].map((feature, idx) => (
              <div key={idx} className="feature-card fade-in-element">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div> */}
          <div className="features-grid">
            {featuresList.map((feature, idx) => (
              <div key={idx} className="feature-card fade-in-element">
                <div className="feature-icon">
                  {/* The icon is now a component rendered directly */}
                  {feature.icon}
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>


{/* Live Voice demo section */}
<section id="demo" style={{ padding: '80px 0', textAlign: 'center' }}>
  <h2 className="section-title">Talk to Live Voice Agent Right Now</h2>
  <p style={{ color: 'var(--text-secondary)', marginBottom: '30px' }}>Experience our Live AI Agent voice technology by clicking the agent.</p>
  <TalkingBot />
</section>



      {/* Products Section */}
 <section id="products" className="products">
  <div className="container">
    <h2 className="section-title fade-in-element">Our Intelligent AI Agents</h2>
    
    {/* Category Tabs */}
    <div className="filter-buttons fade-in-element">
      {Object.keys(agentCategories).map(cat => (
        <button 
          key={cat} 
          className={`filter-btn ${activeCategory === cat ? 'active' : ''}`}
          onClick={() => setActiveCategory(cat)}
        >
          {cat}
        </button>
      ))}
    </div>

    {/* Agents Grid */}
    <div className="products-grid">
      {agentCategories[activeCategory].map((agent, idx) => (
        <div key={idx} className="product-card fade-in-element">
          <div className="product-header">
            {/* <span className="product-icon">🤖</span> */}
            <h3>{agent}</h3>
          </div>
          <p className="product-desc">Advanced {activeCategory=== "Others" ? " AI" : activeCategory} automation powered by our proprietary AI engine.</p>
          <button className="btn-add"  onClick={() => {
                setIsContactModalOpen(true);
                setIsNavOpen(false);
              }}>Deploy Agent</button>
        </div>
      ))}
    </div>
  </div>
</section>
      {/* Pricing Section */}
      <section id="pricing" className="pricing">
        <div className="container">
          <h2 className="section-title fade-in-element">
            Flexible Pricing Plans
          </h2>

          <div className="pricing-grid">
            {[
              // {
              //   name: "Starter",
              //   price: 99,
              //   features: [
              //     "1 AI Tool",
              //     "Up to 10k requests/mo",
              //     "Basic support",
              //     "Community access",
              //   ],
              // },
              // {
              //   name: "Professional",
              //   price: 499,
              //   features: [
              //     "5 AI Tools",
              //     "Unlimited requests",
              //     "Priority support",
              //     "Custom integrations",
              //   ],
              //   featured: true,
              // },
              {
                name: "",
                price: "Custom",
                features: [
                  "All AI Tools",
                  "Unlimited everything",
                  "24/7 dedicated support",
                  "Custom SLA",
                ],
              },
            ].map((plan, idx) => (
              <div
                key={idx}
                className={`pricing-card fade-in-element ${plan.featured ? "featured" : ""}`}
              >
                <h3>{plan.name}</h3>
                <div className="price">
                  {typeof plan.price === "number" ? (
                    <>
                      <span className="currency">$</span>
                      <span className="amount">{plan.price}</span>
                      <span className="period">/mo</span>
                    </>
                  ) : (
                    <span className="custom">{plan.price}</span>
                  )}
                </div>
                <ul className="plan-features">
                  {plan.features.map((feat, i) => (
                    <li key={i}>✓ {feat}</li>
                  ))}
                </ul>
                <button className="btn btn-outline"   onClick={() => {
                setIsContactModalOpen(true);
                setIsNavOpen(false);
              }}>Choose Plan</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      {/* <section className="testimonials">
  <h2 className="section-title fade-in-element">Trusted by Industry Leaders</h2>
  <div className="testimonial-grid">
    {[
      { name: "Sarah Jenkins", role: "CEO, TechFlow", quote: "Cyfrowy.ai transformed our customer engagement metrics in just one month." },
      { name: "Mark Wilson", role: "CTO, FinScale", quote: "The most seamless AI integration we've ever experienced." },
      
    ].map((t, i) => (
      <div key={i} className="testimonial-card fade-in-element">
        <p>"{t.quote}"</p>
        <h4>{t.name}</h4>
        <span>{t.role}</span>
      </div>
    ))}
  </div>
</section> */}

      {/* Auto-Sliding Testimonials */}
      <section className="testimonials-wrapper">
        <h2 className="section-title">Trusted by Industry Leaders </h2>
        <div className="testimonial-track">
          {[...testimonials, ...testimonials].map((t, i) => (
            <div key={i} className="testimonial-card">
              <p>"{t.quote}"</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  marginTop: "1rem",
                }}
              >
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    background: "var(--accent-secondary)",
                  }}
                ></div>
                <div>
                  <h4 style={{ fontSize: "1rem" }}>{t.name}</h4>
                  <span style={{ fontSize: "0.8rem" }}>{t.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-background">
          <div className="cta-orb orb-1"></div>
          <div className="cta-orb orb-2"></div>
        </div>

        <div className="cta-content fade-in-element">
          <h2>Ready to Transform Your Business?</h2>
          <p>
            Join thousands of companies using Cyfrowy.ai to accelerate growth
          </p>
          <button
            className="btn btn-primary btn-large"
            onClick={() => {
              setIsContactModalOpen(true);
              setIsNavOpen(false);
            }}
          >
            Get Started Now
          </button>
        </div>
      </section>

      {/* Locations Section */}
      <section id="contact" className="locations">
        <h2 className="section-title">Our Global Offices</h2>
        <div className="locations-grid">
          {[
            {
              city: "Dubai",
              address:
                "19th floor,48 Burj Gate Tower, Sheikh Zayed Road, Down Town, Dubai, UAE",
              phone: "+971 44030700",
              email: "info@cyfrowytechnologies.com",
            },
            {
              city: "India",
              address:
                "7th floor,Cathedral Rd, Gopalapuram, Chennai, Tamil Nadu 600086",
              phone: "+971 44030700",
              email: "info@cyfrowytechnologies.com",
            },
            {
              city: "UK",
              address: "Innovation Hub, London, UK",
              phone: "+44 20 7890 1234",
              email: "info@cyfrowytechnologies.com",
            },
          ].map((loc, i) => (
            <div key={i} className="location-card">
              <h3>{loc.city}</h3>
              <p>{loc.address}</p>

              <strong>{loc.phone}</strong>
              <p>{loc.email}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Cyfrowy.ai</h4>
            <p>Empowering businesses with next-generation AI solutions.</p>
          </div>

          <div className="footer-section">
            <h4>Product</h4>
            <ul>
              <li>
                <a href="#products">Solutions</a>
              </li>
              <li>
                <a href="#pricing">Pricing</a>
              </li>
              <li>
                <a href="#">Documentation</a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li>
                <a href="#">About</a>
              </li>
              <li>
                <a href="#">Blog</a>
              </li>
              <li>
                <a href="#">Careers</a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li>
                <a href="#">Privacy</a>
              </li>
              <li>
                <a href="#">Terms</a>
              </li>
              <li>
                <a href="#">Security</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Cyfrowy.ai. All rights reserved.</p>
          <div className="social-links">
            <a href="#">
              <BsTwitterX size={20} />
            </a>
            <a href="#">
              <FaLinkedin size={20} />
            </a>
            <a href="#">
              <FaFacebook size={20} />
            </a>
            <a href="#">
              <FaSquareInstagram size={20} />
            </a>
            <a href="#">
              <IoLogoWhatsapp size={20} />
            </a>
          </div>
        </div>
      </footer>

      {/* Auth Modal */}
      <Modal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        title="Sign In"
      >
        <form className="modal-form">
          <input type="email" placeholder="Email Address" required />
          <input type="password" placeholder="Password" required />
          <button type="submit" className="btn btn-primary">
            Login
          </button>
        </form>
      </Modal>

      {/* Contact Modal */}
      <Modal
        isOpen={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
        title="Contact Sales"
      >
        <form className="modal-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Business Email" required />
          <textarea placeholder="How can we help?" rows="4"></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </Modal>

      {/* Floating Bot Launcher */}
      <button
        className="bot-launcher"
        onClick={() => setIsBotOpen(!isBotOpen)}
        aria-label="Open AI Chat Assistant"
      >
        <GiRobotHelmet size={30} />
      </button>

      {/* Bot Overlay */}
      {isBotOpen && (
        <div className="bot-overlay-wrapper">
          <AIBotWidget isOpen={isBotOpen} onClose={() => setIsBotOpen(false)} />
        </div>
      )}
    </div>
  );
};

export default CyfrowyAI;
